export default "__VITE_ASSET__2a1ae368__"